$( document ).ready(function() {

  if($('.bannerslider').length > 0) {
    $('.bannerslider').owlCarousel({
      autoplay: true,
      autoplayTimeout:5000,
      loop: true,
      nav: false,
      dots: true,
      items: 1,
      responsive : {
        0 : {
          dots: false,
        },
        1024 : {
          dots: true,
        }
      }
    })
  }
});

